import React from 'react'
import { observer } from 'mobx-react'
import { useModel, useModelKey } from '@morningtrain/react-resources'
import { getMapValue } from '@morningtrain/react-helpers'

function EditQuantity ({ name }) {
  const model = useModel()
  const id = useModelKey()

  const defaultQuantity = getMapValue(model, name)

  const [quantity, setQuantity] = React.useState(defaultQuantity)

  React.useEffect(() => {
    model.set(name, quantity)
  }, [quantity])

  return (
    <div className='quantity-input'>
      <div onClick={() => setQuantity(quantity - 1)} className='quantity-input__btn-wrap'>
        <button type='button'>-</button>
      </div>

      <div className='quantity-input__text'>
        <input value={quantity} onChange={e => setQuantity(parseInt(e.target.value) || quantity)} />
      </div>

      <div onClick={() => setQuantity(quantity + 1)} className='quantity-input__btn-wrap'>
        <button type='button'>+</button>
      </div>
    </div>
  )
}

export default observer(EditQuantity)
